import {makeAutoObservable} from "mobx"

export interface TenantConfig {
    tenant: string
    path: string
    display: string
    authority: string
}

class TenantStore {
    private set configs(value: TenantConfig[]) {
        this._configs = value;
    }
    get configs(): TenantConfig[] {
        return this._configs
    }
    get tenant(): string | undefined {
        return this._tenant
    }

    set tenant(value: string | undefined) {
        this._tenant = value
    }
    get tenants(): string[] {
        return this._tenants
    }
    private set tenants(value: string[]) {
        this._tenants = value
    }
    get path(): string | undefined {
        return this.config?.path
    }

    get config(): TenantConfig | undefined {
        return this.getConfig(this.tenant)
    }

    private _tenant: string | undefined = undefined

    private _tenants: string[] = []
    private _configs: TenantConfig[] = []
    constructor() {
        makeAutoObservable(this)
        this.loadTenants().finally(() => {
            const pathSegments = window.location.pathname.split('/')
            if (pathSegments.length > 1 && pathSegments[1]) {
                this.tenant = this.getTenantByUrlSegment(pathSegments[1])
            } else if(this.tenants.length === 1) {
                this.tenant = this.tenants[0]
                window.location.href = `${this.getConfig(this.tenants[0])?.path}/dashboard`
            }
        })
    }

    async loadTenants() {
        let jsonData;
        try {
            jsonData = await (await fetch('/tenants.json')).json()
        } catch (e) {
            jsonData = await (await fetch('/test-tenants.json')).json()
        }

        if (jsonData) {
            const data = jsonData as string[]
            this.configs = data.map(tenant => ({
                tenant: tenant,
                path: `/${tenant}`,
                display: tenant,
                authority: `${process.env.REACT_APP_OIDC_AUTHORITY_BASE}${tenant}`
            }))
            this.tenants = data
        }
    }

    getConfig(tenant: string | undefined): TenantConfig | undefined {
        if (!tenant) {
            return undefined
        }
        return this.configs.filter(cfg => cfg.tenant === tenant)[0]
    }

    getTenantByUrlSegment(segment: string): string | undefined {
        const index = this.tenants.indexOf(segment)
        return this.tenants[index]
    }

    getTenantByAuthority(iss: string | undefined): string | undefined {
        if (!iss) {
            return undefined
        }
        const config = this.configs.filter(cfg => cfg.authority === iss)[0]
        return config?.tenant
    }
}

const tenantStore = new TenantStore()

export {
    tenantStore
}
